import { createContext } from 'react';
import { BondsTableType } from './type';

export const bondsTableTypeContext = createContext<BondsTableType | null>(null);
